import React, { createContext } from 'react';

import { WsSalesRole, WsSalesSolutionItem } from '../../core';




export type WsSalesSolutionSaveOptions = {
  roles?: WsSalesRole[];
  generateRom?: boolean;
  generateSolutionPlan?: boolean;
  generateProposal?: boolean;
  createAepRecord?: boolean;
  setItemsState?: boolean;
  showSuccess?: boolean;
};




type WsSalesSolutionContextProps = {
  salesCapabilitiesConfig: any[];

  salesProcess: any; // TODO: use type
  setSalesProcess: (value: any) => void; // TODO: use type

  items: WsSalesSolutionItem[];
  setItems: React.Dispatch<React.SetStateAction<WsSalesSolutionItem[]>>;

  currentStep: number;
  createOrSave: (step: number, options?: WsSalesSolutionSaveOptions) => Promise<void>;

  showDocumentsPanel: boolean;
  setShowDocumentsPanel: React.Dispatch<React.SetStateAction<boolean>>;

  showResourcesDialog: boolean;
  setShowResourcesDialog: React.Dispatch<React.SetStateAction<boolean>>;

  // closePanel: () => void;
};




const initialValues: WsSalesSolutionContextProps = {
  salesCapabilitiesConfig: [],
  salesProcess: undefined,
  setSalesProcess(value) {
    console.log('WsSalesSolutionContext : setSalesProcess');
  },
  items: [],
  setItems: () => {
    console.log('WsSalesSolutionContext : setItems');
  },
  currentStep: 1,
  createOrSave: async () => {
    console.log('WsSalesSolutionContext : createOrSave');
  },

  showDocumentsPanel: false,
  setShowDocumentsPanel: () => {
    console.log('WsSalesSolutionContext : setShowDocumentsPanel');
  },

  showResourcesDialog: false,
  setShowResourcesDialog: () => {
    console.log('WsSalesSolutionContext : setShowResourcesDialog');
  },

  // closePanel: () => {
  //   console.log('WsSalesSolutionContext : closePanel');
  // }
};




const WsSalesSolutionContext = createContext<WsSalesSolutionContextProps>(initialValues);




export {
  WsSalesSolutionContext
};
